import type { ReactNode } from 'react';

export type PillColor =
  'gray' | 'blue' | 'green' | 'yellow' | 'red' | 'purple' | 'orange' | 'teal' | 'pink';

/** Satter Status-Chip mit Punkt — Farbe trägt Information (offen/in Arbeit/…). */
export function StatusPill({
  color = 'gray',
  children,
}: {
  color?: PillColor;
  children: ReactNode;
}) {
  return (
    <span className={`au-pill au-pill--${color}`}>
      <span className="au-pill__dot" aria-hidden />
      {children}
    </span>
  );
}

/** Farbige Tag-/Label-Pille ohne Punkt (Kategorien, Schlagworte). */
export function Tag({ color = 'gray', children }: { color?: PillColor; children: ReactNode }) {
  return <span className={`au-tag au-pill--${color}`}>{children}</span>;
}
